import React from "react";
import { useLocation } from "react-router-dom";

function TextDivider() {
  const { pathname } = useLocation();

  const pageText = {
    "/": "Play Hard. Rock Loud. Experience Together.",
    "/Basketball": "Dribble. Shoot. Score. Repeat.",
    "/Volleyball": "Serve. Set. Spike.",
    "/Pickleball": "Fast Hands. Smart Shots. Endless Fun.",
    "/FlagFootball": "Run Fast. Pull Flags. Make Plays."
  };

  return (
    <div className="text-divider">
      <h2 className="futuraPTMedium">{pageText[pathname] ?? "Play Hard. Rock Loud. Experience Together."}</h2>
    </div>
  );
}

export default TextDivider;